<mat-form-field appearance="outline" class="w-100">
  <mat-label>Provincia</mat-label>
  <input
    type="text"
    matInput
    [formControl]="provinceControl"
    [matAutocomplete]="provinceAuto"
    placeholder="Seleccione una provincia"
    [attr.aria-busy]="(provincesBusy$ | async) ? 'true' : null"
  />
  <gd-input-busy
    matSuffix
    label="Cargando provincias..."
    [busy]="provincesBusy$ | async"
  ></gd-input-busy>
  <mat-autocomplete
    #provinceAuto="matAutocomplete"
    (optionSelected)="onProvinceChange($event.option.value)"
  >
    <mat-option
      *ngFor="let province of filteredProvinces$ | async"
      [value]="province.name"
    >
      {{ province.name }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>

<mat-form-field appearance="outline" class="w-100">
  <mat-label>Ciudad</mat-label>
  <input
    type="text"
    matInput
    [formControl]="cityControl"
    [matAutocomplete]="cityAuto"
    placeholder="Seleccione una ciudad"
    [attr.aria-busy]="(citiesBusy$ | async) ? 'true' : null"
  />
  <gd-input-busy
    matSuffix
    label="Cargando ciudades..."
    [busy]="citiesBusy$ | async"
  ></gd-input-busy>
  <mat-autocomplete #cityAuto="matAutocomplete">
    <mat-option
      *ngFor="let city of filteredCities$ | async"
      [value]="city.name"
    >
      {{ city.name }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
